module.exports = __webpack_public_path__ + "static/media/assyrian_preview.ff0226b3.png";